import { get, post, put, destroy } from '@/api/request';

function fetchComments(params = {}) {
  return get('/comments', params);
}

function createComment(data) {
  return post('/comments', data);
}

function updateComment({ id, data }) {
  return put(`/comments/${id}`, data);
}

function deleteComment(id) {
  return destroy(`/comments/${id}`);
}

export default {
  fetchComments,
  createComment,
  updateComment,
  deleteComment,
};



// WEBPACK FOOTER //
// ./src/store/modules/comment/api.js